export function YesterdayVideosIcon({
  className = "size-5",
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M16.6663 8.7513V5.66797C16.6663 4.26784 16.6663 3.56777 16.3939 3.03299C16.1542 2.56259 15.7717 2.18014 15.3013 1.94045C14.7665 1.66797 14.0665 1.66797 12.6663 1.66797H7.33301C5.93288 1.66797 5.23281 1.66797 4.69803 1.94045C4.22763 2.18014 3.84517 2.56259 3.60549 3.03299C3.33301 3.56777 3.33301 4.26784 3.33301 5.66797V14.3346C3.33301 15.7348 3.33301 16.4348 3.60549 16.9696C3.84517 17.44 4.22763 17.8225 4.69803 18.0622C5.23281 18.3346 5.93288 18.3346 7.33301 18.3346H9.99967M11.6663 9.16797H6.66634M8.33301 12.5013H6.66634M13.333 5.83464H6.66634M14.9997 17.5013V12.5013M12.4997 15.0013H17.4997" stroke="#101828" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}
export const displayName = "YesterdayVideosIcon";
